<template>
	<div class="car-details_car-view">
		<!-- Движение по дороге -->
		<div v-if="routeCar">
			<div class="car-details_car-road"
					 v-if="routeCar.type === 0"
					 v-bind:style="{ 'animation-duration': 20 / stateCar.speed + 's'}">
			</div>
		</div>

		<!-- Цвет всей машины -->
		<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/car_color.svg')" style="opacity: 0">
		<div class='car-details_car-color'
				 v-bind:style="{ background : carColor,
							maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/car_color.svg') + ')' }">
		</div>

		<div class="car-details_car-state">
			<!-- Общий каркас -->
			<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/car.svg')">
			<!-- Передняя левая дверь -->
			<div v-if="stateCar.is_fl_door_open">
				<div class='car-details_car-color'
						 v-bind:style="{ background : '#ffffff',
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_left_color.svg') + ')' }">
				</div>
				<div class='car-details_car-color'
						 v-bind:style="{ background : carColor,
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_left_color.svg') + ')' }">
				</div>
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/door_left.svg')">
			</div>
			<!-- Передняя правая дверь -->
			<div v-if="stateCar.is_fr_door_open">
				<div class='car-details_car-color'
						 v-bind:style="{ background : '#ffffff',
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_right_color.svg') + ')' }">
				</div>
				<div class='car-details_car-color'
						 v-bind:style="{ background : carColor,
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_right_color.svg') + ')' }">
				</div>
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/door_right.svg')">
			</div>
			<!-- Задняя левая дверь -->
			<div v-if="stateCar.is_rl_door_open">
				<div class='car-details_car-color'
						 v-bind:style="{ background : '#ffffff',
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_left_back_color.svg') + ')' }">
				</div>
				<div class='car-details_car-color'
						 v-bind:style="{ background : carColor,
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_left_back_color.svg') + ')' }">
				</div>
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/door_left_back.svg')">
			</div>
			<!-- Задняя правая дверь -->
			<div v-if="stateCar.is_rr_door_open">
				<div class='car-details_car-color'
						 v-bind:style="{ background : '#ffffff',
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_right_back_color.svg') + ')' }">
				</div>
				<div class='car-details_car-color'
						 v-bind:style="{ background : carColor,
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/door_right_back_color.svg') + ')' }">
				</div>
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/door_right_back.svg')">
			</div>
			<!-- Капот открыт -->
			<div v-if="stateCar.is_hood_open">
				<div class='car-details_car-color'
						 v-bind:style="{ background : '#ffffff',
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/hood_color.svg') + ')' }">
				</div>
				<div class='car-details_car-color'
						 v-bind:style="{ background : carColor,
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/hood_color.svg') + ')' }">
				</div>
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/hood.svg')">
			</div>
			<!-- Поворотники -->
			<div>
				<img class='car-details_car-lightTurn' v-if="stateCar.is_l_turn_signal" v-bind:src="require('../../../assets/img/car-color/' + carBody + '/light_turn_l.svg')">
				<img class='car-details_car-lightTurn' v-if="stateCar.is_r_turn_signal" v-bind:src="require('../../../assets/img/car-color/' + carBody + '/light_turn_r.svg')">
			</div>
			<!-- Двигатель -->
			<div v-if="stateCar.engine && stateCar.engine.is_running">
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/engine_one.svg')">
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/engine_two.svg')" class="car-details_car-engine__shake">
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/engine_three.svg')" class="car-details_car-engine__fade">
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/engine_four.svg')">

				<!-- Капот открыт -->
				<div v-if="!stateCar.is_hood_open">
					<div style="opacity: 0.7">
						<div class='car-details_car-color'
								 v-bind:style="{ background : '#ffffff',
																 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/engine_five_color.svg') + ')' }">
						</div>
						<div class='car-details_car-color'
								 v-bind:style="{ background : carColor,
																 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/engine_five_color.svg') + ')' }">
						</div>
					</div>
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/engine_five.svg')">
				</div>
				<div v-else>
					<div class='car-details_car-color'
							 v-bind:style="{ background : '#ffffff',
														 	 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/engine_six_color.svg') + ')' }">
					</div>
					<div class='car-details_car-color'
							 v-bind:style="{ background : carColor,
														 	 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/engine_six_color.svg') + ')' }">
					</div>
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/engine_six.svg')">
				</div>

				<!-- -->
				<div class="car-details_car-smoke">
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/smoke_one.svg')">
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/smoke_two.svg')">
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/smoke_three.svg')">
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/smoke_four.svg')">
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/smoke_five.svg')">
					<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/smoke_six.svg')">
				</div>
			</div>

			<!-- Багажник открыт -->
			<div v-if="stateCar.is_trunk_open">
				<div class='car-details_car-color'
						 v-bind:style="{ background : '#ffffff',
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/trank_open_color.svg') + ')' }">
				</div>
				<div class='car-details_car-color'
						 v-bind:style="{ background : carColor,
														 maskImage : 'url(' + require('../../../assets/img/car-color/' + carBody + '/trank_open_color.svg') + ')' }">
				</div>
				<img v-bind:src="require('../../../assets/img/car-color/' + carBody + '/trank_open.svg')">
				<img v-if="stateCar.is_brake_pressed"   v-bind:src="require('../../../assets/img/car-color/' + carBody + '/trank_open_light_stop.svg')">
				<img v-if="stateCar.is_lights_on"  			v-bind:src="require('../../../assets/img/car-color/' + carBody + '/trank_open_light_front.svg')">
			</div>
			<!-- Свет, когда багажник закрыт -->
			<div v-if="!stateCar.is_trunk_open">
				<img v-if="stateCar.is_brake_pressed"   v-bind:src="require('../../../assets/img/car-color/' + carBody + '/light_stop.svg')">
				<img v-if="stateCar.is_lights_on"  			v-bind:src="require('../../../assets/img/car-color/' + carBody + '/light_front.svg')">
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    data(){
      return{

			}
		},
		computed : {
      currentCar : function(){
        return this.$store.state.cars.current
			},
      stateCar : function(){
        return this.$store.state.cars.state[this.currentCar.id]
      },
      routeCar : function(){
        return this.$store.state.cars.route[this.currentCar.id]
      },

			carColor : function(){
        let num = this.$store.state.cars.list[ this.currentCar.index ].body_color;

        return 'RGB(' + (num >> 16 & 0xFF) + ',' + (num >> 8 & 0xFF) + ',' + (num >> 0 & 0xFF) + ')';
			},
			carBody : function () {
        let res;
				const a = this.$store.state.cars.list[ this.currentCar.index ].body_style;

				switch (a){
					case 1 :
					  res = 'hatch';
						break;
					case 2 :
            res = 'universal';
						break;
					case 3 :
            res = 'suv';
						break;
					case 4 :
					  res = 'bus';
						break;
          case 10 :
            res = 'tank'
					  break;
					default :
					  res = 'sedan';
            break;
				}
				return res;
      }
		}
  }
</script>